export default [
	{
		author: '',
		title: 'What is EIA?',
		body: 'Environmental Impact Assessment is the process of systematically identifying, predicting, evaluating and mitigating the likely significant effects (both beneficial and adverse) of proposed developments. This process is reported in an Environmental Statement.',
	},

	{
		author: '',
		title: 'What is EIA Screening?',
		body: 'EIA Screening is a procedure used to determine whether a proposed project is likely to have significant effects on the environment and forms the first stage of the EIA process which results in a key EIA decision. It will determine whether an EIA is needed for the proposed project and if so, to what detail. <eia-link href="https://assets.publishing.service.gov.uk/government/uploads/system/uploads/attachment_data/file/630689/eia-thresholds-table.pdf">Screening thresholds</eia-link> are defined for different types of developments in UK legislation.',
	},

	{
		author: '',
		title: 'What is meant by "sensitive area"?',
		body: `This is defined in the <eia-link href="https://www.legislation.gov.uk/uksi/2017/571/regulation/2/made">Town and Country Planning (EIA) Regulations 2017</eia-link> to be any of the following:
				<eia-ordered-list>
					<eia-list-item>Sites of Special Scientific Interest;</eia-list-item>
					<eia-list-item>National Park;</eia-list-item>
					<eia-list-item>the Broads;</eia-list-item>
					<eia-list-item>World Heritage Site;</eia-list-item>
					<eia-list-item>Scheduled Monument;</eia-list-item>
					<eia-list-item>Area of Outstanding Natural Beauty;</eia-list-item>
					<eia-list-item>European site.</eia-list-item>
				</eia-ordered-list>`,
	},

	{
		author: '',
		title: 'How is it established if my project is in an environmentally sensitive area?',
		body: `An auto-check will determine if the site boundary of your proposed development is located within/close proximity to an environmentally sensitive area.`,
	},

	{
		author: '',
		title: 'What are the main environmental topics analysed during screening process?',
		body: `The following categories will be investigated if EIA screening is deemed necessary: Natural resources and Waste, Pollution and Nuisances, Transport and Access, Population (socio-economic factors) and Human Health, Water Resources and Flood Risk, Biodiversity and Arboriculture, Landscape/Townscape and Visual, Cultural Heritage, Archaeology, Land use and Soils, Wind Microclimate, Daylight, Sunlight, Overshadowing, Solar Glare, Climate and Greenhouse Gases, Natural Disasters, Electromagnetic fields, and effects and cumulation with other development.`,
	},

	{
		author: '',
		title: 'If my project may require EIA Screening, what happens next?',
		body: `If there's a potential need for EIA Screening, a request for an EIA Screening Opinion will be required from the council. This would need to be supported by an EIA Screening appraisal report.`,
	},

	{
		author: '',
		title: 'What happens if my project requires EIA?',
		body: `An Environmental Statement would need to be submitted with the planning application. This is normally preceded by a Scoping process to determine which environmental topics are likely to give rise to significant effects and, therefore, are to be included in the ES and assessed further through the EIA process.`,
	},
];
